import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=20699c3a&scoped=true&"
import script from "./FormSwitch.vue?vue&type=script&lang=js&"
export * from "./FormSwitch.vue?vue&type=script&lang=js&"
import style0 from "./FormSwitch.vue?vue&type=style&index=0&id=20699c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20699c3a",
  null
  
)

export default component.exports